import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Link from 'next/link';

import { NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID } from '@/constants/addresses';
import { CHAIN_IDS } from '@/constants/chain';

import { useTokenRoute } from '@/hooks/useTokenRoute';

import { ChevronDownIcon } from '@/ui/Icons/ChevronDownIcon';

import { useMatchaWallets } from '../../../hooks/useMatchaWallets';
import { buttons } from '../../../styles/buttons';
import { popover } from '../../../styles/popover';
import { fontStyles } from '../../../styles/typography';
import { getConnectedChain } from '../../../utils/wallet';
import { FeaturesPageNavigationMenu } from '../FeaturesPageNavigationMenu';
import { HeaderBase } from '../HeaderBase';
import { MatchaLogoButton } from '../MatchaLogoButton';
import { NavigationDropdownList } from '../NavigationDropdownList';

export function MarketingPageHeader() {
  const { base } = popover();
  const { ethereumWallet } = useMatchaWallets();
  const tokenRoute = useTokenRoute();
  const chainId = getConnectedChain(ethereumWallet)?.id ?? CHAIN_IDS.MAINNET;
  return (
    <HeaderBase>
      <div className="flex items-center">
        <MatchaLogoButton />
      </div>
      <div className="items-center justify-center hidden tablet:flex">
        <FeaturesPageNavigationMenu />
      </div>
      <nav className="flex gap-2 justify-end">
        <Link
          href={tokenRoute({
            address: NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID[chainId],
            chainId,
          })}
        >
          <div
            className={buttons({
              size: 'medium',
              color: 'black',
              shape: 'pill',
            })}
          >
            Open App
          </div>
        </Link>

        <DropdownMenu.Root modal={false}>
          <DropdownMenu.Trigger
            className={buttons({
              size: 'small',
              color: 'transparent',
              shape: 'rounded',
              class: [
                'h-10',
                'p-4',
                'cursor-default',
                'whitespace-nowrap',
                'rounded-full',
                'hover:bg-token-alphalight-200',
                'disabled:bg-token-alphalight-200',
                'disabled:cursor-none',
                'disabled:border',
                'disabled:border-solid',
                'disabled:border-token-gray-300',
                'tablet:hidden',
              ],
            })}
          >
            <span className={fontStyles({ variant: 'LABEL_MD' })}>Menu</span>
            <ChevronDownIcon className="text-token-gray-700 ml-1" />
          </DropdownMenu.Trigger>

          <DropdownMenu.Portal>
            <DropdownMenu.Content align="end" className={base({ class: 'max-w-[332px]' })}>
              <NavigationDropdownList isInFeaturesPage />
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </nav>
    </HeaderBase>
  );
}
